import * as React from "react";
const SvgReadyForDescribing = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" viewBox="0 0 12 12" {...props}><path fill="#FEC125" d="M12 6a6 6 0 1 1-6-6v6z" /></svg>;
export default SvgReadyForDescribing;